import React, { FunctionComponent } from 'react';
import { CompanyRecruitmentDetail, DataCategory, DataValueCompanyPageRecruitments } from '../../../types/companyDetail';

type Props = {
  id: number;
  companyId: number;
  coverNoImg: string;
  dataCategory: DataCategory
  dataValue: DataValueCompanyPageRecruitments;
  detail: CompanyRecruitmentDetail;
};

export const Presentation: FunctionComponent<Props> = ({
  id,
  companyId,
  coverNoImg,
  dataCategory,
  dataValue,
  detail,
}) => {
  const isStopped = detail.release === 'stopped';

  return (
    <a
      href={`/recruitments/${id}`}
      className="company__page__recruitments__wrapper__item gtm-recruitment-view-count"
      data-event-name='recruitments on screen'
      data-event="click"
      data-category={dataCategory}
      data-value={dataValue.selfRecruitments}
      data-recruitmentid={id}
      data-companyid={companyId}
    >
      <div className="company__page__recruitments__wrapper__item--cover">
        {detail.image?.url ? (
          <img src={detail.image.url} alt={`${id}のロゴ写真`} />
        ) : (
          <img src={coverNoImg} alt="no-image" />
        )}
        {isStopped && (
          <p className="company__page__recruitments__wrapper__item--cover--stopped">
            この募集は終了しました。
          </p>
        )}
      </div>
      <div className="company__page__recruitments__wrapper__item__box">
        <p className="company__page__recruitments__wrapper__item__box--occupation">
          {detail.occupationNames}
        </p>
        <p className="company__page__recruitments__wrapper__item__box--title">
          {detail.recruitmentTitle}
        </p>
      </div>
    </a>
  );
};
